// Enumerations
import { KycMethodsEnumeration } from 'containers/kyc/enumerations/kyc-methods.enumeration';
// Resolvers
import { initializeKycMethodResolver } from '../resolvers/kyc-landing.resolver';
// Types
import {
  KycLandingBuilderHandlersType,
  KycLandingMethodBuilderHandlersType,
  KycLandingMethodsHandlersType,
  KycLandingMethodsOnSelectHandlersType,
  KycLandingOnChangeConsentType,
} from './types/kyc-landing.handlers.type';
// Utils
import { getKycNextStateFromMethod } from './utils/kyc-landing.handlers.utils';

const manageKycMethodContinueClickHandler = async ({
  handleTrackConfirm,
  method,
  setError,
  setKycIdentificationId,
  setKycIframeUrl,
  setKycState,
  setSelectedMethod,
}: KycLandingMethodBuilderHandlersType): Promise<void> => {
  setSelectedMethod(method);
  handleTrackConfirm(method);

  const [response, error] = await initializeKycMethodResolver(method);

  if (error) {
    setError(true);
  } else if (response) {
    response?.url && setKycIframeUrl(response?.url);
    response?.identificationId && setKycIdentificationId(response?.identificationId);
    setKycState(getKycNextStateFromMethod(method));
  }
};

const onSelectKycMethodHandler = ({
  handleTrackSelectMethod,
  method,
  setSelectedMethod,
}: KycLandingMethodsOnSelectHandlersType): void => {
  setSelectedMethod(method);
  handleTrackSelectMethod(method);
};

const onChangeVideocallConsentHandler = ({
  handleTrackCheckConsents,
  selectedConsent,
  setSelectedConsent,
}: KycLandingOnChangeConsentType): void => {
  const toggledCheck = !selectedConsent;
  handleTrackCheckConsents({ method: KycMethodsEnumeration.VIDEOCALL, checked: toggledCheck });
  setSelectedConsent(toggledCheck);
};

const KycLandingHandlers = (
  props: KycLandingBuilderHandlersType
): KycLandingMethodsHandlersType => ({
  handleManageKycMethodContinueClick: (method: KycMethodsEnumeration) =>
    manageKycMethodContinueClickHandler({ method, ...props }),
  handleOnSelectKycMethod: (method: KycMethodsEnumeration) =>
    onSelectKycMethodHandler({ method, ...props }),
  handleOnChangeVideocallConsentHandler: () => onChangeVideocallConsentHandler({ ...props }),
});

export { KycLandingHandlers };
